import axiosActionsFactory from '../../axiosHelpers';
import { UrlService } from '../../../../services';
import { getSelectedCompany } from '../../../selectors';

export const SEND_PROVIDER_ACCOUNT_AUTH_CODE = axiosActionsFactory('SEND_PROVIDER_ACCOUNT_AUTH_CODE');

const sendProviderAccountAuthCode = (accountId, contextCompanyId, requestBody) => (dispatch) => dispatch({
  type: SEND_PROVIDER_ACCOUNT_AUTH_CODE.START,
  payload: {
    request: {
      url: UrlService.providerAccountAuthCode(accountId),
      method: 'post',
      data: requestBody,
      params: { contextCompanyId },
    },
  },
});

export const sendAccountAuthCode = (accountId, stateId, authMethods) => (dispatch, getState) => {
  const state = getState();
  const contextCompanyId = getSelectedCompany(state);

  return dispatch(sendProviderAccountAuthCode(accountId, contextCompanyId, { stateId, authMethods }));
};
